import { memo } from 'react'

interface SignaturePreviewProps {
  senderName: string
  personalMessage: string
}

export const SignaturePreview = memo(function SignaturePreview({ senderName, personalMessage }: SignaturePreviewProps) {
  if (!senderName && !personalMessage) return null

  return (
    <div className="p-4 rounded-2xl bg-[var(--tg-theme-secondary-bg-color,#F5F5F5)] border border-[var(--tg-theme-hint-color,#999999)]/20">
      <p className="text-[10px] text-[var(--tg-theme-hint-color,#999999)] uppercase tracking-wider mb-2">Так увидит получатель</p>
      {personalMessage && (
        <p className="text-sm font-semibold text-[var(--tg-theme-text-color,#1A1A1A)] italic text-center leading-relaxed mb-3">
          &laquo;{personalMessage}&raquo;
        </p>
      )}
      <p className="text-xl text-[var(--tg-theme-text-color,#1A1A1A)] text-center italic font-serif">
        {senderName || 'Ваш тайный поклонник чая'}
      </p>
    </div>
  )
})
